import usersEdit from '@/views/users/edit'
import usersList from '@/views/users/list'

export default [
  {
    path: '/utilizadores',
    name: 'usersList',
    component: usersList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'users',
      heading: 'menu.users',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/utilizadores/novo',
    name: 'usersCreate',
    component: usersEdit,
    meta: {
      layout: 'sidebar',
      base: 'users',
      heading: 'menu.users',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/utilizadores/:id/editar',
    name: 'usersUpdate',
    component: usersEdit,
    meta: {
      layout: 'sidebar',
      base: 'users',
      heading: 'menu.users',
      auth: true,
      roles: ['super-admin']
    }
  }
]
